<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <header class="card-header">
            <div class="d-flex">
              <strong class="align-self-center">Projetos</strong>
              <div class="btn-group ml-auto">
                <button v-if="itens && itens.length > 0" class="btn btn-success mr-1" @click="GetExcel">
                  <i class="fas fa-file-excel fa-1x mr-1"></i>Baixar Excel
                </button>
                <a
                  v-permission="'Projeto.Adicionar'"
                  class="btn btn-primary"
                  href="/#/projeto/novo"
                  title="Adicionar novo projeto"
                >
                  Adicionar
                </a>
              </div>
            </div>
          </header>
          <div v-if="loading" class="loading-container">
            <RotateSquare
              class="loading-position animated fadeIn"
              size="60px"
            ></RotateSquare>
          </div>
          <div v-else class="card-body">
            <b-table
              :hover="true"
              responsive
              :items="itens"
              :fields="fields"
              striped
              :per-page="itensPorPagina"
              show-empty
              empty-text="Nenhum projeto encontrado."
            >
              <template v-slot:empty="scope">
                <h4>{{ scope.emptyText }}</h4>
              </template>
              <template v-slot:cell(isGaau)="data">
                <div class="center">
                  <span v-if="data.item.isGaau" class="badge badge-success">
                    Sim
                  </span>
                  <span v-else class="badge badge-secondary">Não</span>
                </div>
              </template>
              <template v-slot:cell(acoes)="data">
                <div class="btn-group-sm">
                  <a
                    class="btn btn-primary mr-2"
                    :href="GetUrlReport(data.item)"
                    title="Visualizar relatório em tabela"
                  >
                    <i class="fas fa-table"></i>
                  </a>
                  <b-button
                    variant="warning"
                    class="mr-2"
                    title="Editar"
                    @click="Edit(data.item)"
                  >
                    <i class="fa fa-edit"></i>
                  </b-button>
                  <b-button
                    variant="danger"
                    title="Remover"
                    @click="Remove(data.item)"
                    v-permission="'Projeto.Remover'"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </b-button>
                </div>
              </template>
            </b-table>
            <b-pagination
              v-model="pagina"
              :total-rows="total"
              :per-page="itensPorPagina"
              align="right"
              size="md"
              class="mt-2"
            ></b-pagination>
            <b-modal
              v-model="modalRemover"
              title="Confirmar exclusão"
              class="modal-danger"
              ok-variant="danger"
              @ok="ModalOk"
              @hidden="ModalCancel"
            >
              Você confirma a exclusão desse registro?
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import ProjectService from "../../servico/ProjectService";
import DateTime from "../../util/DateTime";

export default {
  name: "Project",
  components: {
    RotateSquare
  },
  data() {
    return {
      modalRemover: false,
      itemRemover: null,
      loading: false,
      itens: [],
      pagina: 1,
      total: 0,
      itensPorPagina: 20,
      fields: [
        { key: "name", label: "Nome", sortable: true },
        { key: "address", label: "Endereço", sortable: true },
        { key: "isGaau", label: "GAAU", sortable: true },
        {
          key: "acoes",
          label: "Ações",
          sortable: false,
          thClass: "center, wd-120-px"
        }
      ]
    };
  },
  watch: {
    pagina: function (val) {
      this.GetGrid(val);
    }
  },
  beforeMount() {
    this.GetGrid(1);
  },
  methods: {
    GetExcel() {
      this.loading = true;
      ProjectService.ExportExcel([])
        .then((response) => {
          this.loading = false;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.download = "Projetos.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    GetUrlReport(item) {
      return item.isGaau
        ? "/#/relatorio-gaau/tabela/" + item.id
        : "/#/relatorio-inventario/tabela/" + item.id;
    },
    Edit(usuario) {
      this.$router.push("/projeto/editar/" + usuario.id);
    },
    ModalCancel(evento) {
      evento.preventDefault();
      this.itemRemover = null;
    },
    ModalOk(evento) {
      evento.preventDefault();
      this.modalRemover = false;
      if (!this.itemRemover) return;

      ProjectService.Remove(this.itemRemover.id)
        .then(() => {
          this.GetGrid(1);
          this.$notify({
            data: ["Projeto removido com sucesso."],
            type: "success",
            duration: 5000
          });
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    Remove(item) {
      this.modalRemover = true;
      this.itemRemover = item;
    },
    GetGrid(pagina) {
      this.loading = true;

      ProjectService.GetGrid(pagina)
        .then((response) => {
          this.loading = false;
          this.itens = response.data.itens;
          this.total = response.data.total;
          this.pagina = response.data.pagina;
          this.itensPorPagina = response.data.itensPorPagina;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    }
  }
};
</script>
